export const FETCH_PRODUCTS_LIST = 'FETCH_PRODUCTS_LIST';
export const FETCH_PRODUCTS_LIST_SUCCESS = 'FETCH_PRODUCTS_LIST_SUCCESS';
export const FETCH_PRODUCTS_LIST_FAILURE = 'FETCH_PRODUCTS_LIST_FAILURE';
export const CLEAR_PRODUCTS_LIST = 'CLEAR_PRODUCTS_LIST';
